var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6549 10.7726L7.40316 6.5109L11.6438 2.26024C12.0327 1.87041 12.0327 1.23251 11.6438 0.842685C11.2549 0.452858 10.6185 0.452858 10.2296 0.842685L5.98895 5.09335L1.75935 0.853759C1.37044 0.463933 0.734044 0.463932 0.345135 0.85376C-0.0437737 1.24359 -0.0437741 1.88148 0.345135 2.27131L4.57474 6.5109L0.334086 10.7616C-0.0548226 11.1514 -0.054823 11.7893 0.334086 12.1791C0.722994 12.5689 1.35939 12.5689 1.7483 12.1791L5.98893 7.92847L10.2406 12.1902C10.6295 12.58 11.2659 12.58 11.6548 12.1902C12.0438 11.8004 12.0438 11.1625 11.6549 10.7726Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModalIcon);
export default __webpack_public_path__ + "static/media/CloseModalIcon.8c8fac64f637b0eb6b8b1cce4c8321a2.svg";
export { ForwardRef as ReactComponent };